import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireDotNetExtensive,
  HireDotNetCertified,
  HireDotNetCustomized,
  HireDotNetSeamless,
  HireDotNetTimely,
  HireDotNetSupport,
} from "../../../app-constants";

function Whychoosespeeech() {
  return (
    <section
      className="voice_services why_choose_speech p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Why Choose Us as Your SEO Marketing Agency </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              You must work with the most suitable SEO partner to ensure the
              best growth of your business’s online presence. At TekRevol, we
              can help you develop and implement specific SEO solutions that
              yield tangible outcomes. These values are our driving force, which
              distinguishes us as the right choice for your digital
              transformation and growth.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Proven Track Record</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      These SEO campaigns have always proven a positive impact
                      evidenced by higher rankings and boosted organic traffic
                      for clients.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Data-Driven Approach</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      With the support of data and analytics, we create only the
                      best approaches that will serve your purposes well.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Experienced Team</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our SEO specialists are result-oriented and have extensive
                      experience and professional knowledge in their work.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Transparent Reporting</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      It is our policy to offer comprehensive reports on SEO
                      campaigns’ performance and updates, ensuring you are
                      well-informed about results.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Long-Term Success</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We strive for sustainable development, meaning that all
                      our actions involve both immediate and long-term
                      solutions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head ms-0">
                      <h5>Client-Centric Focus</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Any goal that you have for your digital marketing strategy
                      becomes our goal as well, and we provide you with constant
                      help.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
